import { memo } from 'react';
import { IconHighlight } from '@aimsos/ui';

/**
 * Empty state of a member tab, as the prototype draws it: a soft dashed frame, the icon in a
 * tinted tile, a title and a short text.
 *
 * @param {object} props
 * @param {import('lucide-react').LucideIcon} props.icon
 * @param {string} props.title
 * @param {string} props.subtitle
 */
function MemberTabEmpty({ icon, title, subtitle }) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-edge/60 px-6 py-12 text-center">
      <IconHighlight icon={icon} bgColor="Primary" iconColor="PrimaryAlt" size="medium" />
      <div className="flex max-w-sm flex-col gap-1">
        <p className="text-sm font-semibold text-content-secondary">{title}</p>
        <p className="text-sm text-content-muted">{subtitle}</p>
      </div>
    </div>
  );
}

export default memo(MemberTabEmpty);
